import { Component } from '@angular/core';

@Component({
    selector: 'app-rev-driver-card',
    templateUrl: './rev-driver-card.component.html',
    styleUrls: ['../../common-reporting-dashboard.scss'],
    standalone: false
})
export class RevDriverCardComponent {

}
